module.exports = __webpack_public_path__ + "static/greystarstripe-ca53e6e0704a2db0d7a9b7be982e8b81.jpeg";